<template>
  <UiAlert v-if="newUiEnabled">
    <slot>{{ $t("The list is empty.") }}</slot>
  </UiAlert>

  <b-alert v-else :model-value="true" variant="warning">
    <slot>{{ $t("The list is empty.") }}</slot>
  </b-alert>
</template>

<script setup lang="ts">
import { useNewUiEnabled } from "@/components/newUi/core/useNewUiEnabled";

const newUiEnabled = useNewUiEnabled();
</script>
